<div class="route-details-container">
  <div class="route-info-card" *ngIf="routeData">
    <div class="route-path">
      <div class="location-icon">
        <img [src]="imgConstants.START_LOCATION" alt="start-location" />
      </div>
      <div class="route-locations">
        <span class="start-location">{{ routeData.startLocation }}</span>
        <img [src]="imgConstants.RIGHT_ARROW" alt="right-arrow" />
        <span class="end-location">{{ routeData.endLocation }}</span>
      </div>
    </div>

    <div class="status" *ngIf="!(routeData?.plannedEmployees === 0 
                 && routeData?.signedInEmployees === 0 
                 && routeData?.noShowEmployees === 0 
                 && routeData?.adhocEmployees === 0)">
    <div class="employee-stats">
      <div class="stat-item" *ngFor="let stat of getEmployeeStats()">
        <img [src]="stat.icon" alt="">
        <span class="stat-count">{{ stat.count }}</span>
      </div>
    </div>
    <div class="employee-stats">
      <div class="stat-item">
        <span>Adhoc {{routeData.adhocEmployees}}</span>
      </div>
    </div>
  </div>

  </div>
</div>
